(function () {
  const mediaBanner = () => {
    document.querySelectorAll(".media-banner").forEach((block) => {
      if (block.dataset.iigStickyInitialized === "true") return;

      const box = block.closest("section");
      if (!box || !box.id) return;

      const stickyEffect = block.dataset.stickyEffect === "true";
      if (!stickyEffect) return;

      const normalElement = box.nextElementSibling;
      if (!normalElement || !normalElement.classList.contains("sticky-section")) return;

      block.dataset.iigStickyInitialized = "true";
      let isSticky = false;

      window.addEventListener(
        "scroll",
        function () {
          const stickyTop = box.getBoundingClientRect().top;
          const normalElementTop = normalElement.getBoundingClientRect().top;

          if (stickyTop <= 0 && !isSticky) {
            box.classList.add("sticky-active");
            isSticky = true;
          }

          if (normalElementTop <= 0 && isSticky) {
            box.classList.remove("sticky-active");
            isSticky = false;
          }
        },
        { passive: true },
      );
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    mediaBanner();
    document.addEventListener("shopify:section:load", mediaBanner);
  });
})();
